/**
 * Previews de imágenes base64 en vista Publicidad (mismo patrón que fondos: blob URL liviano).
 */

const store = new Map();
let seq = 0;

export function isPubDataImageUrl(s) {
  return typeof s === 'string' && /^data:image\//i.test(s);
}

export function revokePubPreviewBlobs() {
  store.forEach((v) => {
    if (v.blobUrl) URL.revokeObjectURL(v.blobUrl);
  });
  store.clear();
}

/** @returns {{ refId: string, previewSrc: string }} */
export function registerPubB64Src(dataUrl) {
  const id = `nxpub_${++seq}`;
  try {
    const parts = dataUrl.split(',');
    const header = parts[0] || '';
    const b64data = parts[1] || '';
    const mimeMatch = /^data:([^;]+);/.exec(header);
    const mime = mimeMatch ? mimeMatch[1] : 'image/jpeg';
    const binary = atob(b64data);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    const blobUrl = URL.createObjectURL(new Blob([bytes], { type: mime }));
    store.set(id, { dataUrl, blobUrl });
    return { refId: id, previewSrc: blobUrl };
  } catch {
    store.set(id, { dataUrl, blobUrl: null });
    return { refId: id, previewSrc: dataUrl };
  }
}

export function resolvePubDataUrl(refId) {
  return store.get(refId)?.dataUrl || null;
}
